import { BlogPost } from "names/blog";
import useBlogPosts from "gears/blog/useBlogPosts";
import { POST_INDEX } from "names/blog";

type ReturnType = BlogPost;

const useBlogPost = (index: POST_INDEX): ReturnType => {
  const { postAt } = useBlogPosts();
  return postAt(index);
};

export default useBlogPost;
